/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect } from "react";
import { useDispatch } from "react-redux";
import { AppContext } from "../../../context";
import { post } from "../Common/util";
import * as types from "../../../Actions/actionTypes";

const NetsEasy = React.memo((props) => {
  const { paymentMethods } = props;

  const rdxDispatch = useDispatch();
  const { state } = useContext(AppContext);
  const { config, culture, saleId, currency, userManager } = state;
  const [loaded, setLoaded] = useState(false);

  console.log("NetsEasy (re)render ------------------------ ");

  const startEasyOnePagePaymentProcessUrl = `${config.apiUri}/api/netseasy/onepage/${saleId}?locale=${culture}&currency=${currency}`;
  const completeEasyOnePagePaymentProcessUrl = `${config.apiUri}/api/netseasy/${saleId}/redirect`;

  // Get Nets Easy-specific settings
  let checkoutKey = paymentMethods.netseasy.settings.find(
    (s) => s.key === "CheckoutKey"
  )?.value;
  let checkoutUrl = paymentMethods.netseasy.settings.find(
    (s) => s.key === "CheckoutUrl"
  )?.value;

  // Get Access Token from user
  let accessToken = null;
  userManager.getUser().then((user) => {
    if (user && user.access_token) {
      accessToken = user.access_token;
    }
  });

  // On first render - Add dependencies
  useEffect(() => {
    console.log("-- NetsEasy - Apply script");

    const script = document.createElement("script");
    script.src = checkoutUrl;
    script.async = false;
    document.body.appendChild(script);

    console.log("-- NetsEasy - Applied script");

    setLoaded(true);
    return () => {
      console.log("-- NetsEasy Cleanup - Remove Script");
      document.body.removeChild(script);
    };
  }, []);

  //On first render - Call external api
  useEffect(() => {
    console.log("-- NetsEasy - Call API to start payment process");
    if (loaded === true) {
      const startPaymentProcess = async () => {
        const response = await post(
          accessToken,
          startEasyOnePagePaymentProcessUrl
        );

        if (response.status !== 200) {
          console.log("-- NetsEasy ERROR, status:", response.status);
          rdxDispatch({
            type: types.ERROR,
            payload: "Could_Not_Start_OnePage_Payment_Error",
          });

          //
          //todo: dölj onepage vid error?
          //
        } else {
          const paymentId = await response.text();
          console.log("-- NetsEasy - Called api", paymentId);

          let easyLocale = "sv-SE";
          if (culture) {
            if (culture.includes("en")) easyLocale = "en-US";
            if (culture.includes("da")) easyLocale = "da-DK";
            if (culture.includes("de")) easyLocale = "de-DE";
            if (culture.includes("no")) easyLocale = "nb-NO";
          }
          if (paymentId) {
            const checkoutOptions = {
              checkoutKey: checkoutKey,
              paymentId: paymentId,
              containerId: "checkout-container-div",
              language: easyLocale,
            };
            let checkout = null;

            let interval = setInterval(() => {
              if (checkout === null) {
                try {
                  console.log("trying2");
                  // eslint-disable-next-line no-undef
                  checkout = new Dibs.Checkout(checkoutOptions);
                  checkout.on("payment-completed", function () {
                    window.location =
                      completeEasyOnePagePaymentProcessUrl +
                      "?paymentid=" +
                      paymentId;
                  });
                  console.log("-- NetsEasy - Checkout initiated");
                } catch (err) {
                  console.log("catch", err);
                  interval = null;
                }
              }
              if (checkout !== null) {
                console.log("clearinterval2");
                clearInterval(interval);
              }
            }, 500);
          }
        }
      };
      startPaymentProcess();
    }
  }, [loaded]);

  return (
    <>
      <div id="checkout-container-div"></div>
    </>
  );
});

export default NetsEasy;
